module.exports = __webpack_public_path__ + "img/JDC_LOGO.251efb57.png";